


import React, { useState, useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';
import { ConfigTabProps } from './types';

const ConfigTab: React.FC<ConfigTabProps> = ({ node, handleUpdate }) => {
    const [jsonError, setJsonError] = useState<string | null>(null);
    const [configString, setConfigString] = useState('');

    useEffect(() => {
        setConfigString(JSON.stringify(node.configuration, null, 2));
        setJsonError(null);
    }, [node.configuration]);

    const handleJsonChange = (val: string) => {
        setConfigString(val);
        try {
            const parsed = JSON.parse(val);
            handleUpdate('configuration', parsed);
            setJsonError(null);
        } catch (e) {
            setJsonError("Invalid JSON");
        }
    };

    return (
        <div className="h-full flex flex-col animate-in fade-in slide-in-from-bottom-2 duration-300">
            <div className="mb-4">
                <h3 className="text-xs font-bold text-slate-900 uppercase tracking-wider mb-2">Raw JSON Configuration</h3>
                <p className="text-xs text-slate-500">Edit the advanced configuration object for this schedule directly.</p>
            </div>
            <div className="flex-1 relative">
                <textarea 
                    value={configString}
                    onChange={(e) => handleJsonChange(e.target.value)}
                    className={`w-full h-96 p-4 font-mono text-xs border rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500/20 resize-none text-slate-900 ${jsonError ? 'border-red-500 focus:border-red-500 bg-red-50' : 'border-slate-300 focus:border-teal-500 bg-slate-50'}`}
                />
                {jsonError && (
                    <div className="absolute bottom-4 right-4 bg-red-100 text-red-700 px-3 py-1.5 rounded-lg text-xs font-medium border border-red-200 shadow-sm flex items-center gap-2">
                        <AlertTriangle size={14} />
                        {jsonError}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ConfigTab;